import { generatePath } from 'react-router-dom';
import { FORM_MODE_TO_PATH_MAP } from 'config/routes';
import { MODULE_NAME, ENTITY, ENTITY_TO_PATH_MAP } from '../config';

export const generateFormPath = ({ accountId, landingPageId, mode, basePath }) => {
    const modePath = FORM_MODE_TO_PATH_MAP[mode];
    const entityPath = ENTITY_TO_PATH_MAP[ENTITY.LANDING_PAGE];

    return generatePath(basePath, {
        accountId,
        landingPageId,
        mode: modePath,
        module: MODULE_NAME,
        entity: entityPath,
    });
};
